import 'simple-module';
import 'simple-hotkeys';
import 'simple-uploader';
import Simditor from 'simditor';
import simditorRU from '../../translate/simditor-locale.ru';
import {debounce} from "debounce";

$(document).ready(function () {

    const $insuranceStatusCheckbox = $('#ProjectsTasks_insurance_status_id');

    $('#ProjectsTasks_category').change(function () {
        let category_id = $(this).val();
        let worker_id = $('#ProjectsTasks_worker_id').val();

        $('.option').remove();
        $('.attribute').remove();

        $('.subCategories').addClass('hidden');
        $('.subCategory_attributes').addClass('hidden');

        if (category_id.length) {
            $.ajax({
                url: '/ajax/getSubCategoryTitles',
                type: 'POST',
                data: {YII_CSRF_TOKEN: token, category_id: category_id, worker_id: worker_id}
            })
                .done(function (response) {
                    response = JSON.parse(response);
                    if (parseInt(response.code) === 0 && response.response) {
                        $('#ProjectsTasks_subCategoryTitle').html('&nbsp;');
                        taskTitles = response.response;
                    }
                });

            $.ajax({
                url: '/ajax/getSubCategory',
                type: 'POST',
                data: {YII_CSRF_TOKEN: token, category_id: category_id, worker_id: worker_id}
            })
                .done(function (response) {
                    response = JSON.parse(response);
                    if (parseInt(response.code) === 0 && response.response) {
                        var tasks = $('#ProjectsTasks_categories_task_id');
                        tasks.select2("val", "");

                        tasks.append(response.response);
                        tasks.parents('.subCategories').removeClass('hidden');
                    }
                });
        }
    });

    $insuranceStatusCheckbox.change(function () {
        let isRequiredAcceptance = $insuranceStatusCheckbox.data('isInsuranceAcceptanceRequired');

        if ($insuranceStatusCheckbox.prop('checked') === false
            || !isRequiredAcceptance
            || isRequiredAcceptance === 'false') {
            return;
        }

        $.SmartMessageBox({
            title: translate.agreement_caption,
            content: translate.damage_compensation_agreement_message,
            buttons: '[' + translate.damage_disagree + '][' + translate.damage_agree + ']'
        }, function (ButtonPressed) {
            if (ButtonPressed === translate.damage_agree) {
                $.ajax({
                    url: '/ajax/damage-compensation-acceptance',
                    type: 'POST',
                    data: {
                        YII_CSRF_TOKEN: token,
                    }
                }).done(function (response) {
                    response = JSON.parse(response);
                    if (parseInt(response.code) === 0) {
                        $insuranceStatusCheckbox.data('isInsuranceAcceptanceRequired', false);
                        $insuranceStatusCheckbox.prop('checked', true);
                        checkCommission();
                    } else {
                        $insuranceStatusCheckbox.prop('checked', false);
                    }
                })
            }
            if (ButtonPressed === translate.damage_disagree) {
                $insuranceStatusCheckbox.prop('checked', false);
            }
        });
    });

    const checkCommission = () => {
        let price = $('#ProjectsTasks_price').val();
        let worker_id = $('#ProjectsTasks_worker_id').val();
        let checkBoxInsurance = $insuranceStatusCheckbox && $insuranceStatusCheckbox.prop('checked') ? 1 : 0;
        let sub_category_id = $('#ProjectsTasks_categories_task_id').val();
        let isNew = $('#edit-task-form').attr('is-new') === 'true';
        if (price && isNew)
            $.ajax({
                url: '/ajax/get-price-with-commission',
                type: 'POST',
                data: {
                    YII_CSRF_TOKEN: token,
                    price: price,
                    worker_id: worker_id,
                    need_insurance: checkBoxInsurance,
                    sub_category_id: sub_category_id
                }
            })
                .done(function (response) {
                    response = JSON.parse(response);
                    if (parseInt(response.code) === 0 && response.response) {
                        $('.with-commission').text(response.response.total);
                        $('.commission-fee-amount').text(response.response.commission);
                        $('.insurance-cost-in-currency').text(response.response.insurance);
                        if (checkBoxInsurance) {
                            $('.task-damage-compensation').css('display', 'inline-flex');
                        } else {
                            $('.task-damage-compensation').css('display', 'none');
                        }
                    } else {
                        $('.task-damage-compensation').css('display', 'none');
                    }
                })
    }

    $('#ProjectsTasks_categories_task_id').change(function () {
        var subCategory = $(this).val();
        const userId = $('#ProjectsTasks_worker_id')[0] ? $('#ProjectsTasks_worker_id')[0].value : null;
        checkInsured(userId, subCategory);
    })

    $('#ProjectsTasks_worker_id').change(function () {
        var userId = $(this).val();
        var categoryId = $('#ProjectsTasks_categories_task_id').val();
        checkInsured(userId, categoryId);
    })

    $('.header-info-collapse').click(event => {
        if ($(event.target).attr('aria-expanded') === 'false') {
            $(event.target.childNodes[0]).removeClass('fa-plus');
            $(event.target.childNodes[0]).addClass('fa-times');
        } else {
            $(event.target.childNodes[0]).removeClass('fa-times');
            $(event.target.childNodes[0]).addClass('fa-plus');
        }
    });

    const checkInsured = (userId, categoryId) => {
        if (categoryId && userId) {
            let isRequiredAcceptance = $insuranceStatusCheckbox.data('isInsuranceAcceptanceRequired');

            $.ajax({
                url: `/ajax/canTaskBeInsured?userId=${userId}&categoryId=${categoryId}`,
                type: 'GET'
            })
                .done((response) => {
                    if (response) {
                        const resJSON = JSON.parse(response);
                        if (resJSON && resJSON.response && resJSON.response.result) {
                            $('#task-insurance').css('display', 'flex');
                            $('.insurance-cost').text(resJSON.response.cost);
                            // if the customer already accepted the insurance condition (popup) we can check this checkbox
                            // if he didn't do that, he will need to accept the condition (on popup) on the cost`s screen
                            if (resJSON.response.insureByDefault && !isRequiredAcceptance) {
                                $insuranceStatusCheckbox.prop('checked', true);
                                $insuranceStatusCheckbox.trigger('change');
                            }
                        } else {
                            $('#task-insurance').css('display', 'none');
                            $insuranceStatusCheckbox.prop('checked', false);
                            checkCommission();
                        }
                    }
                })
        } else {
            $('#task-insurance').css('display', 'none');
            $insuranceStatusCheckbox.prop('checked', false);
            checkCommission();
        }
    }

    const userId = $('#ProjectsTasks_worker_id')[0] ? $('#ProjectsTasks_worker_id')[0].value : null;
    const categoryId = $('#ProjectsTasks_categories_task_id').val();
    checkInsured(userId, categoryId);

    $('.edit-task').on('change', '#ProjectsTasks_categories_task_id', function () {
        var subCategory_id = $(this).val();

        $('#ProjectsTasks_subCategoryTitle').text(taskTitles[subCategory_id]);

        $('.attribute').remove();
        $('.subCategory_attributes').addClass('hidden');

        if (subCategory_id.length) {
            $.ajax({
                url: '/ajax/getSubCategoryAttributes',
                type: 'POST',
                data: {YII_CSRF_TOKEN: token, subCategory_id: subCategory_id}
            })
                .done(function (response) {
                    response = JSON.parse(response);
                    if (parseInt(response.code) === 0 && response.response) {
                        $('.subCategory_attributes').removeClass('hidden').find('legend').after(response.response);
                        $('.subCategory_attributes').find('.select2').select2({
                            placeholder: translate.selectAttributeValue,
                            allowClear: true
                        });
                        $('#ProjectsTasks_category_attributes-error').empty();
                    }
                })
        }
    });

    let debounceCheckCommission = debounce(() => checkCommission(), 500);

    $('#ProjectsTasks_price').on('keyup change blur input', function () {
        let value = $(this).val();
        if (value.length > 20) {
            $(this).val(value.slice(0, 20));
            return false;
        }

        debounceCheckCommission();
    });
    $('#ProjectsTasks_worker_id').on('change', function () {
        checkCommission();
    });
    $insuranceStatusCheckbox.on('change', function () {
        checkCommission();
    });
    $('#ProjectsTasks_categories_task_id').on('change', function () {
        checkCommission();
    });

    $('#ProjectsTasks_worker_id').on('change', function () {
        var error = $('#ProjectsTasks_worker_id').find('option[value=' + $(this).val() + ']').attr('data-error');
        if (error == 1 || error == 2) {
            $.smallBox({
                title: translate.task_worker,
                content: error == 1 ? translate.task_worker_freelancer : translate.task_worker_selfemployed,
                color: "#C46A69",
                timeout: 20000,
                icon: "fa fa-warning shake animated"
            });
        }
    });

    $('fieldset').on('keyup', '.days-other, #ProjectsTasks_date_end', function () {
        $(this).val('');
    });

    if ($('#virtual_ProjectsTasks_description').get(0)) {
        Simditor.i18n['ru-RU'] = simditorRU;
        Simditor.locale = 'ru-RU';
        const toolbar = [
            'title', 'bold', 'italic', 'underline', 'strikethrough',
            '|',
            'ol', 'ul', 'code', 'table',
            'link'
        ];

        const editor = new Simditor({
            textarea: $('#virtual_ProjectsTasks_description').get(0),
            toolbar: toolbar
        });

        editor.on('valuechanged', (e, src) => {
            $('#ProjectsTasks_description').val(editor.getValue())
        });
    }

    function bindMaxNumber() {
        $('input[type=number][max]').bind('change keyup click', function () {
            // we dont allow even typing price larger than max
            var max = parseInt($(this).prop('max'));
            if ($(this).val() !== '' && $(this).val() > max) {
                $(this).val(max);
            }
        });
    }

    bindMaxNumber();

    $('.freelancers-select2').select2({
        width: "100%",
        ajax: {
            delay: 500,
            url: '/ajax/freelancers-search',
            data: function (params) {
                var query = {
                    search: params.term,
                    page: params.page || 1
                }
                return query;
            },
            processResults: function (response, params) {
                response = JSON.parse(response);
                if (parseInt(response.code) !== 0 || response.response === undefined) {
                    return {results: null, pagination: false};
                }

                return response.response;
            }
        }
    });

  $('.js-gtm-tasks_task_clicks').click((e) => {
    const taskIdAttr = e.target.attributes.getNamedItem('data-task-id');
    const taskId = taskIdAttr ? taskIdAttr.value : '0';
    const userIdEl = document.getElementById('userId');
    const userId = userIdEl ? userIdEl.content : '0'
    try {
        window.dataLayer.push({ event: 'tasks_task_clicks', task_num: taskId, click_id: 'edit', user_id: userId });
    } catch (_) {}
  });
});
